$(function() {
    if(!$('body').hasClass('bodyProduct')) {
        return;
    }

    var $productJumpBar = $('#product-jump-bar');
    var $productName = $('.product-name.cleanDesc');
    var $productJumpBarMobile = $('#product-jump-bar-mobile');
    var $addToCartBtn = $('.cart-btn-wrapper');
    var $productMiniBar = $('#product-mini-bar');
    var barTop = $productJumpBar.offset().top - $productJumpBar.height();
    var addToCartBtnTop = $addToCartBtn.offset().top;
    var productNameTop = $productName.offset().top;

    var $fitmentFits = $('.fitment.fits');
    var $fitmentNoFit = $('.fitment.nofit');
    var $fitmentDesc = $('.fitment.fit-desc');
    var $fitmentSelector = $('.product-vehicle-select');
    var $mobileCarousel = $('#product-mobile-carousel');

    var vehicleSelector = new VehicleSelectorV2($('.vehicle-selector-stepwise-container-product'));

    var vehicleSelectedCallback = function(result) {
        $('.fitment-loading').removeClass('d-none');
        
        // set brand link href
        var brandLink = $('.js-brand-link').data('brand-link');
        if (result.vehicleGroupURL) {
          brandLink = '/' + result.vehicleGroupURL + brandLink;
        }
        $('.js-brand-link').attr('href', brandLink);
        
        $.ajax({
            method: 'GET',
            url: '/fitsVehicle/',
            data: {
                productID : tmsProductID
            }
        }).done(function(response) {
            $('.fitment-loading').addClass('d-none');
            $fitmentFits.addClass('d-none');
            $fitmentNoFit.addClass('d-none');
            $fitmentDesc.addClass('d-none');
            $fitmentSelector.addClass('d-none');
            if (response.fitsVehicle === -1 && $.trim(response.alineTxt)!='') {
                $fitmentDesc.removeClass('d-none');
                $('.fitment').find('.vehicle-desc').html(response.alineTxt);
             } else {
                if(response.fitsVehicle != 0) {
                    $fitmentFits.removeClass('d-none');
                }
                else {
                    $fitmentNoFit.removeClass('d-none');
                }                
                $('.fitment').find('.vehicle-name').html(result.vehicleLabel);
             }
            $('#product-vehicle-select-modal').modal('hide');
        }).fail(function(error) {
            console.log(error);
        });
    };

    $('[data-toggle="popover"]').popover();

    $('[data-target="#product-vehicle-select-modal"]').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('#product-vehicle-select-modal').modal('show');
    });

    vehicleSelector.onHasSelectedVehicle(function() {
        $('.product-vehicle-select').addClass('d-none');
    });

    vehicleSelector.onHasNoSelectedVehicle(function() {
        $('.product-vehicle-select').removeClass('d-none');
        $('.fitment-loading').addClass('d-none');
    });

    vehicleSelector.onVehicleSelected(vehicleSelectedCallback);

    vehicleSelector.onHasPartialVehicleSelected(function() {
        $('.fitment-loading').addClass('d-none');
        $fitmentFits.addClass('d-none');
        $fitmentNoFit.addClass('d-none');
        $fitmentDesc.addClass('d-none');
        $fitmentSelector.removeClass('d-none');
    });

    vehicleSelector.init();

    $(document).on('scroll', function() {
        var docTop = $(document).scrollTop();

        if(addToCartBtnTop){
            if(docTop >= addToCartBtnTop && !$productMiniBar.hasClass('d-flex')) {
                $productMiniBar.addClass('d-flex');
            }
            if(docTop < addToCartBtnTop) {
                $productMiniBar.removeClass('d-flex');
            }
        } else {
            if(docTop >= productNameTop && !$productMiniBar.hasClass('d-flex')) {
                $productMiniBar.addClass('d-flex');
            }
            if(docTop < productNameTop) {
                $productMiniBar.removeClass('d-flex');
            }
        }

        if(docTop >= barTop && !$productJumpBar.hasClass('fixed-top')) {
            $productJumpBar.addClass('fixed-top');
            $productJumpBar.removeClass('mt-4');
            $('.productpage').addClass('jump-bar-fixed');
        }

        if(docTop < barTop) {
            $productJumpBar.removeClass('fixed-top');
            $productJumpBar.addClass('mt-4');
            $('.productpage').removeClass('jump-bar-fixed');
        }

        var sectionIds = [
            $('#nav-product-details'),
            $('#nav-product-kit-contents'),
            $('#nav-product-installation'),
            $('#tabReviews'),
            $('#tabQa'),
            $('#nav-product-fitment')
        ];

        sectionIds.forEach(function($item) {
            if(!$item.length) {
                return;
            }
            if($item.offset().top - docTop < ($productJumpBar.height() + $productMiniBar.height() + 65)) {
                sectionIds.forEach(function($item) {
                    $productJumpBar.find('a[href="#'+$item.attr('id')+'"]').parent().removeClass('active');
                });
                $productJumpBar.find('a[href="#'+$item.attr('id')+'"]').parent().addClass('active');
            }
        });
    });

    $productJumpBar.find('a').on('click', function(e) {
        e.preventDefault();
        var id = $(this).attr('href');
        if($productJumpBar.hasClass('fixed-top')){
            $(document).scrollTop($(id).offset().top - ($productJumpBar.height() + $productMiniBar.height() + 40));
        } else {
            $(document).scrollTop($(id).offset().top - ($productJumpBar.height() + $productMiniBar.height() + 160));
        }
    });

    $productJumpBarMobile.find('a').on('click', function(e) {
        e.preventDefault();
        var id = $(this).attr('href');
        $(document).scrollTop($(id).offset().top - 100);
    });

    $('.product-quantity').find('input').on('input', function(e) {
        var val = $(this).val();
        $('.product-quantity').find('input').each(function() {
           if($(this).val() !== val) {
               $(this).val(val);
           }
        });
    });

    $('#productreviews-summary').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $target = $(e.target);
        if($target.attr('href') && $target.attr('href') !== '') {
            var id = $target.attr('href');
            if($productJumpBar.hasClass('fixed-top')){
                $(document).scrollTop($(id).offset().top - ($productJumpBar.height() + $productMiniBar.height() + 40));
            } else {
                $(document).scrollTop($(id).offset().top - ($productJumpBar.height() + $productMiniBar.height() + 160));
            }
        }
    });

    $('[data-target="#product-pdk-modal"]').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $contents = $('#tabKitContents').clone();

        $contents.find('.actualPDKComponents').removeClass('actualPDKComponents');

        $contents.find('input[type="radio"],input[type="checkbox"]').each(function() {
            $(this).parent().addClass('pl-0');
            if(!$(this).is(':checked')) {
                $(this).parents('.product-pdk-option').remove();
            }
            $(this).remove();
        });

        // Remove any options groups that could now be empty
        $contents.find('.kitcontents').each(function() {
            if ($(this).find('.product-pdk-option').length == 0) {
                $(this).remove();
            }
        });

        $contents.find('h4').remove();
        $contents.find('.product-pdk-container').find('button').remove();
        $contents.find('.product-pdk-container').find('.js-suggest-check-container').remove();

        $('#product-pdk-modal').find('.content').html($contents);
        $('#product-pdk-modal').modal('show');
    });
});
